// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__sVN1_","title":"styles_title__My1Fp","imageOverlay":"styles_imageOverlay__sYGzj"};